export const DEFAULT_CROSS_CUTTING_TASK = {
  totalSubtasks: 0,
  totalTasks: 0,
  totalUncompletedSubtasks: 0,
  tasksByThematicBlocks: [],
};
